export default "__VITE_ASSET__CER18eqR__"